/// <reference types="vite/client" />
/// <reference types="../global.d.ts" />
import * as Sentry from "@sentry/react-router"
import { hydrateRoot } from "react-dom/client"
import { HydratedRouter } from "react-router-dom"

const enableSentry =
  import.meta.env.PROD && import.meta.env.ENABLE_SENTRY === "true"
const dsn = import.meta.env.SENTRY_DSN
const release = import.meta.env.SENTRY_RELEASE

if (enableSentry && dsn && release) {
  Sentry.init({
    dsn,
    release,
    sendDefaultPii: true,
    integrations: [Sentry.reactRouterTracingIntegration()],
    enableLogs: true,
    beforeSendLog: (log) => {
      // Drop debug logs in production
      if (log.level === "debug") {
        return null
      }

      // Remove sensitive attributes
      if (log.attributes?.password) {
        delete log.attributes.password
      }
      return log
    },
    beforeSend: (event, hint) => {
      const error = hint?.originalException as Error
      if (error?.name === "AbortError") {
        return null
      }
      return event
    },
    tracesSampleRate: 1.0
  })
}

// Add CloudFront to Vercel fallback for static assets
const setupAssetFallback = () => {
  const cloudfrontUrl = import.meta.env.CLOUDFRONT_URL

  if (!cloudfrontUrl) {
    return
  }

  const errorHandler = (event: Event) => {
    const target = event.target as HTMLElement

    if (target && (target.tagName === "SCRIPT" || target.tagName === "LINK")) {
      const scriptTarget = target as HTMLScriptElement
      const linkTarget = target as HTMLLinkElement
      const assetUrl = scriptTarget.src || linkTarget.href

      if (assetUrl && assetUrl.includes(cloudfrontUrl)) {
        event.preventDefault()
        const fallbackUrl = assetUrl.replace(
          cloudfrontUrl,
          window.location.origin
        )

        if (target.tagName === "SCRIPT") {
          const fallbackScript = document.createElement("script")
          fallbackScript.src = fallbackUrl
          fallbackScript.async = scriptTarget.async
          fallbackScript.defer = scriptTarget.defer
          document.head.appendChild(fallbackScript)
        } else if (target.tagName === "LINK") {
          const fallbackLink = document.createElement("link")
          fallbackLink.rel = "stylesheet"
          fallbackLink.href = fallbackUrl
          document.head.appendChild(fallbackLink)
        }
      }
    }
  }

  window.addEventListener("error", errorHandler)
  ;(window as any).__assetErrorHandler = errorHandler
}

setupAssetFallback()

hydrateRoot(document, <HydratedRouter />)
